export default __webpack_public_path__ + "static/outsource-1250dc47504c3a3f6e89c5bdbe8c6401.png";